export default "__VITE_ASSET__7O2pXH46__"